import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 16px auto;
  grid-gap: 10px;
  color: ${({ theme }) => theme.colors.feedbackState.info.default};
  border: 1px solid ${({ theme }) => theme.colors.feedbackState.info.default};
  background-color: ${({ theme }) => theme.colors.feedbackState.info.disabled};
  border-radius: 12px;
  padding: 17px;
`;
